import {product} from './product';
import {countrySelector} from './country-selector';
import {common} from './common';
import {leadForm} from './lead-form';
import {address} from './address';
import {userMenu} from './user-menu';
import {search} from './search';
import {footer} from './footer';
import {categories} from './categories';
import {homepage} from './homepage';
import {help} from './help';
import {checkout} from './checkout';
import {cart} from './cart';
import {header} from './header';
import {access} from './access';
import {orderReview} from './order-review';
import {registration} from './registration';
import {ctaForm} from './cta-form';

export const en: {[chunkName: string]: {[key: string]: any;};} = {
  address,
  cart,
  categories,
  checkout,
  common,
  countrySelector,
  footer,
  help,
  homepage,
  leadForm,
  product,
  search,
  userMenu,
  header,
  access,
  orderReview,
  registration,
  ctaForm,
};
